<template>
  <div class="overlay"></div>

  <!--HEADER-->
  <page-header :root="root" />

  <!--HERO CAROUSEL-->
  <!-- <hero-carousel /> -->

  <!-- OneSearch -->
  <one-search :root="root" />

  <!--Hours, Quick Links, and Contact-->
  <div class="bg-white position-relative overflow-hidden" role="main" id="content">
    <section class="secton-content-card-row py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12">
            <h1 class="heading-section-color-bg fw-bold">{{ pagetitle }}</h1>
            <div class="row row-eq-height">
              <hours />
              <quicklinks :root="root" />
              <contact-us :root="root" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- Middle Links -->
  <middle-links :root="root" />

  <!-- Events -->
  <upcoming-events :root="root" />

  <!-- Image banners and quicklinks -->
  <!-- <image-banners :root="root" /> -->

  <!-- Chat Widget -->
  <chat />

  <!--Back to Top-->
  <span class="scroll-to-top cursor-pointer" title="Back to top"><i class="far fa-arrow-alt-circle-up"></i></span>

  <!--FOOTER-->
  <page-footer />
</template>

<script>
// @ is an alias to /src
import pageHeader from '@/components/global/header.vue'
import pageFooter from '@/components/global/footer.vue'
import OneSearch from '@/components/oneSearch.vue'
import MiddleLinks from '@/components/middleLinks.vue'
import UpcomingEvents from '@/components/widgets/upcomingEvents.vue'
// import ImageBanners from '@/components/imageBanners.vue'
import ContactUs from '@/components/contactUs.vue'
import quicklinks from '@/components/quickLinks.vue'
import hours from '@/components/widgets/hours.vue'
import chat from '@/components/widgets/chat.vue'

export default {
  name: 'Library-Home',
  components: {
    pageHeader,
    pageFooter,
    OneSearch,
    MiddleLinks,
    UpcomingEvents,
    // ImageBanners,
    ContactUs,
    quicklinks,
    chat,
    hours
  },
  data () {
    return {
      pagetitle: '',
      root: 'https://www.csub.edu'
    }
  },
  watch: {
    '$route' (to) {
      document.title = to.meta.title
      this.pagetitle = to.meta.title
    }
  }
}
</script>

<style>
  :root {
    --csub-gold: #FFC72C;
    --csub-blue: #003594;
  }
</style>
